import { useContext } from "react";
import { AppContext } from "../App"; // Importing the collage asset directly like your structure

export default function ServiceDetailHero({ service }) {
  const appContext = useContext(AppContext);

  return (
    <section className="ags-service-hero-section">
      <div className="container">
        <div className="row align-items-center ags-service-hero-row">
          {/* LEFT SIDE: Text Content */}
          <div className="col-lg-5 order-1">
            <div data-aos="fade-right" className="ags-service-hero-content">
              <div className="ags-service-hero-inner">
                <h1 className="ags-service-title mb-3">{service.title}</h1>

                <div className="ags-service-title-divider mb-4" />

                <p className="ags-service-description text-muted">
                  {service.shortDescription}
                </p>

                {/* Desktop Buttons (Hidden on mobile via custom CSS media query) */}
                <div data-aos="fade-up" className="ags-service-hero-actions d-none d-md-flex gap-3 mt-4">
                  <button
                    className="btn btn-secondary btn-rounded px-4 py-2"
                    onClick={() => appContext.navTo({ item: "contact" })}
                  >
                    Request a consultation
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: Image Collage Layout */}
          <div className="col-lg-7 order-2">
            <div data-aos="fade-left" className="ags-service-hero-image-wrapper">
              <img
                src={service.collage}
                alt="Geo Location and Mapping"
                className="img-fluid ags-service-hero-image"
              />
            </div>
          </div>

          {/* BOTTOM: Mobile Action Buttons (Hidden on desktop, stacks gracefully at the bottom) */}
          <div className="col-12 order-3 d-block d-md-none mt-4">
            <div data-aos="fade-up" className="ags-service-hero-mobile-actions d-grid gap-3">
              <button
                className="btn btn-secondary btn-rounded py-3"
                onClick={() => appContext.navTo({ item: "contact" })}
              >
                Request a consultation
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
